export const formatPayableMoney = (value: string | number, currency = 'MXN') =>
  new Intl.NumberFormat('es-MX', { style: 'currency', currency }).format(Number(value))

export const formatPayableDate = (date: string) => date.split('-').reverse().join('/')

export function parsePayableAmount(value: string): number | null {
  if (!/^\d+(?:[.,]\d{1,2})?$/.test(value.trim())) return null
  const amount = Number(value.trim().replace(',', '.'))
  return Number.isFinite(amount) && amount > 0 ? amount : null
}
